import React from 'react';
/**
 * Top breadcrumb trail for the Wacoku Products category page.
 * Self-contained: not shared with other pages.
 */
export function Breadcrumb() {
  return <nav className="text-sm text-gray-500 mb-4" aria-label="Breadcrumb" data-id="element-964">
      <a href="/" className="hover:text-gray-900" data-id="element-965">
        Home
      </a>
      <span className="mx-2" data-id="element-966">/</span>
      <a href="/shop/" className="hover:text-gray-900" data-id="element-967">
        Shop
      </a>
      <span className="mx-2" data-id="element-968">/</span>
      <span className="text-gray-900 font-medium" data-id="element-969">Wacoku Products</span>
    </nav>;
}